import React, { useEffect,useState } from 'react';
import { useLocation } from 'react-router-dom';
import ResultImg from './ResultImg';


function Country(){

    const[count,upcount]=useState([]);
    let location=useLocation();
    
    const ctData=async()=>{
        const res= await fetch(`https://www.themealdb.com/api/json/v1/1/filter.php?a=${location.state}`);
        const realdata=await res.json();
        upcount(realdata.meals)
    }
    useEffect(()=>{
        ctData();
    },[])
    
    return(
        <>
          <h1 style={{textAlign:'center'}}>{location.state}</h1>
            <div className='divresult'>
             
             {
                 (count==null)?(<p>Soory Not Found</p>):count.map((curelem,index)=>{
            return (<ResultImg key={index} imgv={curelem.strMealThumb}
                name={curelem.strMeal} id={curelem.idMeal}
            />)
              
             })}
 
            
             </div>
        </>
    )
}

export default Country;